import { styled } from 'parkdepot-shared/theme'

export const CodeScannerContainer = styled<'div', { $loading: boolean }>('div', ({ $theme, $loading }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale700,
    transition: 'opacity 0.2s ease-in-out',
    height: '60vh',
    overflow: 'hidden',

    ...($loading ? { opacity: 0.1, pointerEvents: 'none' } : {})
}))

export const CodeScannerTitle = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingMedium,
    margin: 0
}))

export const CodeScannerSubtitle = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0
}))

export const OverlayContainer = styled<'div', { $appearence: boolean }>('div', ({ $theme, $appearence }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transition: 'opacity 0.3s ease-in-out',

    ...($appearence ? { opacity: 1 } : { opacity: 0, visibility: 'hidden' })
}))
